import React, { useEffect } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { useQuery } from '@apollo/react-hooks';
import toast from 'react-hot-toast';
import DateTimePicker from 'react-datetime-picker';
import moment from 'moment';
import Input, { MoneyInput, PercentInput, PhoneNumberInput } from '../Input';
import colors from '../../styles/colors';
import Button from '../Button';
import { GET_SUPERADMIN_FILTERS_DATA } from '../../graphql/queries';
import { convertToCents } from '../../util/Price';
import { initialFilterData } from './SuperadminCustomers';

const BreadcrumbWrapper = styled.ul`
  display: flex;
  align-items: center;
  list-style-type: none;
  align-items: center;
  flex-flow: row wrap;
  @media screen and (max-width: 450px) {
    width: 100%;
  }
`;

const BreadCrumbItem = styled.li`
  display: flex;
  align-items: center;
  margin: 0 0 0 10px;
  font-size: 13px;
  cursor: ${(props) => (props.clickable === '1' ? 'pointer' : null)};
  flex-direction: ${(props) => props.direction || 'row'};
  color: ${(props) => (props.clickable === '1' ? colors.seaGreen : null)};
  border: 1px solid ${colors.grey5};
  height: 63px;
  padding: 0 5px;
  max-width: ${(props) => props.maxWidth || 'null'};
  @media screen and (max-width: 450px) {
    width: ${(props) => props.xswidth || '100%'};
    margin-top: 10px;
    flex: ${(props) => props.flex || null};
    max-width: unset;
  }
`;

const BreadcrumbClearButton = styled.li`
  font-size: 15px;
  padding: 0 0 0 10px;
  position: sticky;
  right: -16px;
  /* background: white; */
  cursor: pointer;
  z-index: 5;
  align-items: center;
  display: flex;
  @media screen and (max-width: 450px) {
    right: 0;
    padding: 0 5px 10px 10px;
    margin-top: 20px;
    width: 50%;
    justify-content: center;
  }
`;

const DropdownContainer = styled.div`
  width: ${(props) => props.width || '250px'};
  display: flex;
  flex-direction: ${(props) => props.direction || 'column'};
  margin: ${(props) => props.margin || null};
  align-self: flex-end;
  justify-content: space-between;
  @media screen and (max-width: 450px) {
    width: ${(props) => props.xswidth || null};
  }
`;

const InputContainer = styled.div`
  width: ${(props) => props.width};
  max-width: 100%;

  @media screen and (max-width: 991px) {
    width: ${(props) => props.width || '100%'};
  }
  @media screen and (max-width: 450px) {
    width: ${(props) => props.xswidth || null};
  }
`;

const HeaderStyle = styled.div`
  font-size: 1.2rem;
  color: ${colors.grey3};
  margin: ${(props) => (props.top ? '0px 0px 10px 0px' : '30px 0px 10px 0px')};
`;

const Select = styled.select`
  width: ${(props) => props.width || '100%'};
  height: 25px;
  padding: ${(props) => props.padding || '0px 10px'};
  justify-self: flex-end;
  border-radius: 5px;
  background: #ffffff;
  border: 1px solid #e0e0e0;
  box-sizing: border-box;
  margin: ${(props) => props.margin || '0 0 6px 0'};
  min-width: 45px;
  @media screen and (max-width: 450px) {
    width: ${(props) => props.xswidth || '100%'};
  }
`;

const DatePickerStyles = createGlobalStyle`
  
  .react-datetime-picker__inputGroup__leadingZero{
    display: inline-flex;
    align-items: center;
    // color:black !important;
 }

 .react-datetime-picker__calendar{
   z-index:100;
 }

 .react-calendar {
  color:black;
  font-weight:500;
  font-size: 11px !important;
  font-family:'Poppins', sans-serif !important;
  
 }
 .react-datetime-picker__button{
  padding: 0 6px;
 }

 .react-datetime-picker__inputGroup__divider {
    padding: 1px 1px;
 }
  .react-datetime-picker__inputGroup__input, 
  .react-datetime-picker__inputGroup__leadingZero, 
  .react-datetime-picker__inputGroup__divider{
    color: ${colors.black} !important;
    -webkit-text-fill-color: ${colors.black};
    opacity: 1; /* required on iOS */   
    height: -webkit-fill-available;
  }

  .react-datetime-picker {
    @media screen and (max-width:450px){
      flex:1.5;

    }
  }

  .react-datetime-picker__wrapper{
    border-radius:4px;
    height: 25px;
    font-size: 13px;
    border: 1px solid ${colors.grey5};
    margin-bottom: 4px;
   
    @media screen and (max-width:450px){
      width: max-content;
      display: flex;
      padding:0 30px;
      

    }
  }

  .react-datetime-picker__button svg {
   stroke: grey  ;
  }
  /* .react-datetime-picker__clear-button{
   display:none 
  } */
  .react-datetime-picker__inputGroup{
    padding: 0px 5px;
  }

  .react-calendar button{
    height:35px;
  }
  .react-datetime-picker__inputGroup__input:invalid{
    background-color:white;
  }
  `;

const moneyFields = [
  'totalCreditGranted',
  'totalCreditRedeemed',
  'currentAvailableBalance',
  'totalCouponsAcceptedRef',
  'totalCouponsRedRef',
];

const FilterBar = ({
  filterData,
  setFilterData,
  filterApplied,

  setSearchQuery,
}) => {
  const { data } = useQuery(GET_SUPERADMIN_FILTERS_DATA);

  const getFilteredContacts = () => {
    const amountType = moneyFields.includes(filterData.credits?.type)
      ? 'currency'
      : 'numeric';

    const allFilters = {
      phoneNumber: filterData.phoneNumber,
      organizationId: filterData.organizationId,
      credits: {
        ...filterData.credits,
        amount:
          amountType === 'currency'
            ? convertToCents(filterData.credits.amount)
            : filterData.credits.amount,
      },
      originalSource: filterData.originalSource,
      optInMethod: filterData.optInMethod,
      timestamp: filterData.timestamp,
    };

    for (const [key, value] of Object.entries(allFilters)) {
      switch (key) {
      case 'credits': {
        if (!value?.amount) {
          delete allFilters.credits;
        }
        break;
      }
      case 'timestamp': {
        if (!value?.value) {
          delete allFilters.timestamp;
        }
        break;
      }
      default: {
        if (!value) {
          delete allFilters[key];
        }
      }
      }
    }

    if (Object.keys(allFilters).length > 0) {
      setSearchQuery((old) => ({
        ...old,
        type: 'allContacts',
        searchQuery: allFilters,
      }));
    } else {
      toast.error('At least 1 filter is required to load contacts');
    }
  };

  useEffect(() => {
    setTimeout(() => {
      const yearInput = document.getElementsByName('year');
      const monthInput = document.getElementsByName('month');
      const dayInput = document.getElementsByName('day');
      if (yearInput[0] && monthInput[0] && dayInput[0]) {
        yearInput[0].setAttribute('disabled', true);
        monthInput[0].setAttribute('disabled', true);
        dayInput[0].setAttribute('disabled', true);
      }
    }, 0);
  }, []);

  return (
    <>
      <BreadcrumbWrapper>
        <BreadCrumbItem maxWidth="170px">
          <PhoneNumberInput
            type="tel"
            header="Phone Number"
            height="25px"
            value={filterData.phoneNumber}
            onChange={(e) => setFilterData({ ...filterData, phoneNumber: e.target.value })}
            width="100%"
            top
          />
        </BreadCrumbItem>
        <BreadCrumbItem>
          <DropdownContainer width="150px" xswidth="100%">
            <InputContainer>
              <HeaderStyle top>Clients</HeaderStyle>
              <Select
                value={filterData.organizationId || ''}
                onChange={(e) => {
                  // Capture the value immediately to avoid event pooling issues in production
                  const newValue = e?.target?.value ?? e?.currentTarget?.value ?? '';
                  if (newValue !== undefined) {
                    setFilterData((old) => ({
                      ...old,
                      organizationId: newValue,
                    }));
                  }
                }}
              >
                <option value="">Select Client</option>
                {data?.getSuperAdminFiltersData?.organizations?.map((client) => {
                  return (
                    <option key={client._id} value={client._id}>
                      {client.name}
                    </option>
                  );
                })}
              </Select>
            </InputContainer>
          </DropdownContainer>
        </BreadCrumbItem>

        <BreadCrumbItem direction="column">
          <DropdownContainer width="100%" xswidth="24%%">
            <Select
              value={filterData.credits?.type}
              margin="2px 0 3px 0"
              onChange={(e) => {
                // Capture the value immediately to avoid event pooling issues in production
                const newValue = e?.target?.value ?? e?.currentTarget?.value ?? '';
                if (newValue !== undefined) {
                  setFilterData((old) => ({
                    ...old,
                    credits: { ...old.credits, type: newValue },
                  }));
                }
              }}
            >
              <option value="currentAvailableBalance">Current Balance</option>
              <option value="totalCreditGranted">Credits Granted</option>
              <option value="totalCreditRedeemed">Credits Redeemed</option>
              <option value="totalCouponsAcceptedRef">
                Ref Discounts Accepted
              </option>
              <option value="totalCouponsRedRef">Ref Discounts Redeemed</option>
              <option value="totalCouponsGranted">Coupons Granted</option>
              <option value="totalCouponsRedeemed">Coupons Redeemed</option>
              <option value="totalConversionRateRef">
                Ref Conversion Rate
              </option>
              <option value="totalRefClicks">Ref Clicks</option>

            </Select>
          </DropdownContainer>

          <DropdownContainer direction="row" width="100%" xswidth="100%">
            <Select
              value={filterData.credits?.mustBe}
              padding="0 3px"
              margin="0 5px 0 0"
              width="24%"
              xswidth="24%"
              onChange={(e) => {
                // Capture the value immediately to avoid event pooling issues in production
                const newValue = e?.target?.value ?? e?.currentTarget?.value ?? '';
                if (newValue !== undefined) {
                  setFilterData((old) => ({
                    ...old,
                    credits: { ...old.credits, mustBe: newValue },
                  }));
                }
              }}
            >
              <option value=">=">{'>='}</option>
              <option value="<=">{'<='}</option>
            </Select>

            {filterData.credits?.type === 'totalConversionRateRef' ? (
              <PercentInput
                type="number"
                height="25px"
                value={filterData.credits?.amount}
                onChange={(e) => {
                  setFilterData({
                    ...filterData,
                    credits: {
                      ...filterData.credits,
                      amount: parseInt(e.target.value),
                    },
                  });
                }}
                width="100%"
                margin="0 0 7px 0"
                top
              />
            ) : (
              <>
                {moneyFields.includes(filterData.credits?.type) ? (
                  <MoneyInput
                    type="number"
                    height="25px"
                    value={filterData.credits?.amount}
                    onChange={(e) => {
                      setFilterData({
                        ...filterData,
                        credits: {
                          ...filterData.credits,
                          amount: parseInt(e.target.value),
                        },
                      });
                    }}
                    width="100%"
                    margin="0 0 7px 0"
                    top
                  />
                ) : (
                  <Input
                    type="number"
                    height="25px"
                    value={filterData.credits?.amount}
                    onChange={(e) => {
                      setFilterData({
                        ...filterData,
                        credits: {
                          ...filterData.credits,
                          amount: parseInt(e.target.value),
                        },
                      });
                    }}
                    width="100%"
                    margin="0 0 7px 0"
                    top
                  />
                )}
              </>
            )}
          </DropdownContainer>
        </BreadCrumbItem>

        <BreadCrumbItem flex="1">
          <DropdownContainer width="100px" xswidth="100%">
            <HeaderStyle top>Original Source</HeaderStyle>
            <Select
              value={filterData.originalSource}
              onChange={(e) => {
                // Capture the value immediately to avoid event pooling issues in production
                const newValue = e?.target?.value ?? e?.currentTarget?.value ?? '';
                if (newValue !== undefined) {
                  setFilterData((old) => ({
                    ...old,
                    originalSource: newValue,
                  }));
                }
              }}
            >
              <option value="">Select</option>
              <option value="SELF">SELF</option>
              <option value="ORG">ORG</option>
              <option value="REF">REF</option>
              <option value="SMS">SMS</option>
            </Select>
          </DropdownContainer>
        </BreadCrumbItem>

        <BreadCrumbItem flex="1">
          <DropdownContainer width="100px" xswidth="100%">
            <HeaderStyle top>Opt-in Method</HeaderStyle>
            <Select
              value={filterData.optInMethod}
              onChange={(e) => {
                // Capture the value immediately to avoid event pooling issues in production
                const newValue = e?.target?.value ?? e?.currentTarget?.value ?? '';
                if (newValue !== undefined) {
                  setFilterData((old) => ({
                    ...old,
                    optInMethod: newValue,
                  }));
                }
              }}
            >
              <option value="">Select</option>
              <option value="QRCODE">QR CODE</option>
              <option value="KEYWORD">KEYWORD</option>
            </Select>
          </DropdownContainer>
        </BreadCrumbItem>

        <BreadCrumbItem direction="column">
          <DropdownContainer width="100%" xswidth="24%%">
            <Select
              value={filterData.timestamp?.type}
              margin="2px 0 3px 0"
              onChange={(e) => {
                // Capture the value immediately to avoid event pooling issues in production
                const newValue = e?.target?.value ?? e?.currentTarget?.value ?? '';
                if (newValue !== undefined) {
                  setFilterData((old) => ({
                    ...old,
                    timestamp: { ...old.timestamp, type: newValue },
                  }));
                }
              }}
            >
              {/* <option value="select">Select Credits Type</option> */}
              <option value="createdAt">Created At</option>
              <option value="lastImported">Last Import</option>
              <option value="lastOptIn">Last Opt-In</option>
              <option value="optOut">Opt-Out</option>
              <option value="smsCampaignOptOut">SMS Opt-Out </option>
            </Select>
          </DropdownContainer>

          <DropdownContainer direction="row" width="100%" xswidth="100%">
            <Select
              value={filterData.timestamp?.mustBe}
              padding="0 3px"
              margin="0 5px 0 0"
              width="24%"
              xswidth="24%"
              onChange={(e) => {
                // Capture the value immediately to avoid event pooling issues in production
                const mustBe = e?.target?.value ?? e?.currentTarget?.value ?? '';
                if (mustBe === undefined) return;

                if (mustBe === '<=') {
                  setFilterData((old) => ({
                    ...old,

                    timestamp: {
                      ...old.timestamp,
                      value: moment(old.selectedDate)
                        .set({
                          hour: 23,
                          minute: 59,
                          second: 59,
                          millisecond: 0,
                        })
                        .unix(),
                      mustBe: mustBe,
                    },
                  }));
                } else {
                  setFilterData((old) => ({
                    ...old,

                    timestamp: {
                      ...old.timestamp,
                      value: moment(old.selectedDate).unix(),
                      mustBe: mustBe,
                    },
                  }));
                }
              }}
            >
              <option value=">=">{'>='}</option>
              <option value="<=">{'<='}</option>
            </Select>

            <DatePickerStyles />
            <DateTimePicker
              value={filterData.selectedDate}
              onChange={(newDate) => {
                const mustBe = filterData.timestamp?.mustBe;

                if (mustBe === '<=') {
                  setFilterData((old) => ({
                    ...old,
                    selectedDate: newDate,
                    timestamp: {
                      ...old.timestamp,
                      value: moment(newDate)
                        .set({
                          hour: 23,
                          minute: 59,
                          second: 59,
                          millisecond: 0,
                        })
                        .unix(),
                    },
                  }));
                } else {
                  setFilterData((old) => ({
                    ...old,
                    selectedDate: newDate,
                    timestamp: {
                      ...old.timestamp,
                      value: moment(newDate).unix(),
                    },
                  }));
                }
              }}
              maxDate={new Date()}
              format="MM-dd-y"
              disableClock
              showLeadingZeros={true}
              required
            />
          </DropdownContainer>
        </BreadCrumbItem>

        <BreadcrumbClearButton>
          <Button
            type="button"
            onClick={() => getFilteredContacts()}
            text="Apply"
            padding="0px"
            minWidth="100px"
            minHeight="30px"
            height="30px"
            width="max-content"
          />
        </BreadcrumbClearButton>
        {filterApplied && (
          <BreadcrumbClearButton>
            <Button
              type="button"
              onClick={() => {
                setFilterData(initialFilterData);
                setSearchQuery({ type: 'clear' });
              }}
              text="Clear All"
              padding="0px"
              minWidth="100px"
              minHeight="30px"
              height="30px"
              width="max-content"
            />
          </BreadcrumbClearButton>
        )}
      </BreadcrumbWrapper>
    </>
  );
};

export default FilterBar;
